module.exports = __webpack_public_path__ + "static/media/my_assets_header.2e6ee899.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_header.png
// module id = 747
// module chunks = 0 1